import { newCreditCardActions, useAppDispatch } from '../../../data/store';
import { Popup } from '../../../../../../ui/popup/popup';

const RememberMePopup = () => {

    const dispatch = useAppDispatch();

    const closeHandler = () => {
        dispatch(
            newCreditCardActions.main({
                rememberMePopupShown: false,
            })
        );
    };

    return (
        <Popup width="400px" height="270px" close={ closeHandler }>
            <div className="flex flex-col justify-center items-center w-full h-full my-4 text-center">

                <p className="mb-2">REMEMBER THIS CARD</p>
                <p className="mb-4">for future purchases on waves.com</p>
                <p className="mb-4">Your credit card details will be encrypted and saved on a secured server. You may choose to remove
                    them at any time.</p>

                <button
                    type="button"
                    className="w-btn"
                    onClick={ closeHandler }
                    style={{ width: '170px' }}>OK</button>
            </div>
        </Popup>
    )
};

export default RememberMePopup;